<template>
  <div class="bg-white mt-5 rounded p-3 px-5">
    <div class="w-full flex flex-col md:flex-row border-b py-5 mb-6">
      <div
        class="w-32 h-32 p-4 -mt-20 ml-2 mb-2 text-white rounded-lg relative flex-no-shrink mr-5 "
        :class="page.icon_color ? page.icon_color : 'bg-tertiary'"
      >
        <icon name="videoettes"></icon>
      </div>

      <div class="w-full flex justify-between items-end">
        <div class="flex items-start">
          <h1 class="text-xl self-end mb-3 uppercase font-medium">Video Branding Tool</h1>
        </div>
        <div
          v-if="saving !== null"
          class="text-lg font-medium"
        >
          <i class="fas fa-spinner fa-pulse fa-lg mr-2"></i>
          Saving your presets
        </div>
      </div>
    </div>

    <div class="w-full flex flex-col items-start md:flex-row">
      <div class="w-full flex flex-col md:mr-8">
        <div class="w-full flex items-start">
          <div class="w-2/5 flex flex-col mr-12">
            <label class="text-xs uppercase">Video Name:</label>
            <input
              class="bg-white outline-none rounded h-11 p-3 shadow border mt-2"
              v-model="videoName"
            />
            <small class="block mt-1 text-red-dark">{{ errors.get('name') }}</small>
          </div>
          <div v-if="fc_network_array.indexOf(system.networks[0].id) === -1" class="w-2/5 flex flex-col">
            <label class="text-xs uppercase mb-2">Merge with videoette:</label>
            <div>
              <button
                v-if="!mergeVideoette"
                class="bg-tertiary font-bold rounded flex items-center w-48 pl-4 py-1"
                @click="showModal = true"
              >
                <icon
                  name="videoettes"
                  class="w-8 text-white"
                  :center="false"
                />
                <span class="text-sm text-primary font-thin text-white bg-tertiary ml-3">Select Videoette</span>
              </button>
            </div>

            <div
              v-if="mergeVideoette"
              class="container rounded shadow flex text-xs relative h-12"
            >
              <div
                v-if="mergeVideoette.image"
                class="bg-cover videoette-image-preview rounded-l"
                :style="{
                  backgroundImage: `url(${ mergeVideoette.image })`
                }"
              ></div>
              <div class="flex-grow pl-2 self-center">
                <strong>{{ truncate(mergeVideoette.display_address, 30) }}</strong>
                <p>{{ mergeVideoette.address_postcode }}</p>
              </div>
              <span class="absolute pin-r mr-1 mt-1 cursor-pointer">
                <i
                  class="fas fa-times"
                  @click="storemergeVideoetteOption(null)"
                ></i>
              </span>
            </div>

            <modal
              v-if="showModal"
              :scrollY="false"
              @leave="showModal = null"
              v-on:ChangeView="showModal = null"
              :showCloseBtn="true"
              :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 min-w-1/2'"
            >
              <videoette-selector v-model="mergeVideoette" />
            </modal>
          </div>
        </div>
        <div class="w-full flex flex-col mt-10">
          <h1 class="text-base mb-4 font-semibold">Upload Video File:</h1>
          <div class="w-full flex flex-col">
            <div class="text-grey text-xs mb-1">
              Please note: The maximum accepted video length is 10 minutes
            </div>
            <div
              class="relative flex flex-col items-center justify-center border border-grey rounded border-dashed"
              :class="{ 'h-120': !file }"
            >
              <button
                v-if="file"
                class="absolute p-1 pin-t pin-r cursor-pointer z-50"
                @click.prevent="removefile"
              >
                <i class="fas fa-times fa-fw text-white"></i>
              </button>
              <input
                v-show="!file"
                type="file"
                class="input-file absolute pin-t pin-l h-full w-full opacity-0"
                @change="loadVideo"
                ref="videoFile"
                accept="video/mp4,video/*"
              />
              <video
                v-show="file"
                controls
                id="videoLength"
                class="pin-t pin-l h-full w-full"
              ></video>
              <button
                v-if="!file"
                class="bg-tertiary font-bold px-3 rounded mt-2 chooseFileButton inline-flex items-center justify-center w-48 mb-5"
              >
                <icon
                  name="videoettes"
                  class="w-10 mr-3 text-white ico"
                  :center="false"
                />
                <span class="text-sm font-thin text-primary text-white text-center">Choose file</span>
              </button>
              <p
                v-if="!file"
                class="call-to-action text-sm font-thin text-center py-4"
              >
                Click or drag and drop
                <br />your video here
              </p>
            </div>
            <div class="text-red-dark text-xs my-1">
              {{ errors.get('video') }}
            </div>
            <modal
              v-if="showModalVideo"
              @leave="showModalVideo = false"
            >
              <button
                type="button"
                @click="showModalVideo = false"
                class="flex items-start"
              >
                <i class="fas fa-times" />
              </button>
              <div class="flex container flex-col items-center">
                <div
                  class="w-16 h-16 text-white rounded-lg flex-wrap content-center mb-5"
                  :class="page.icon_color ? page.icon_color : 'bg-tertiary'"
                >
                  <icon name="videoettes"></icon>
                </div>
                <p>Video length needs to be 10 minutes or less</p>
              </div>
            </modal>
          </div>
          <div class="w-full flex flex-col justify-center items-center mt-4">
            <div
              v-if="uploadPercent > 0"
              class="w-full mb-10"
            >
              <div class="text-sm mb-2 text-grey text-right">
                {{ uploadPercent }}% Uploaded
              </div>
              <div class="h-2 w-full bg-primary rounded">
                <div
                  class="h-full bg-secondary rounded anim-width"
                  :style="{
                    width: `${uploadPercent}%`
                  }"
                ></div>
              </div>
            </div>

            <button
              class="mb-6 py-1 pl-2 pr-4 bg-secondary invisible md:visible rounded flex items-center"
              :class="{ 'cursor-not-allowd': !file }"
              :disabled="!office || !file || loading || saving"
              @click="generate()"
            >
              <icon
                class="w-10 h-10"
                name="tick_circle"
                :center="false"
              />
              {{ loading ? 'Submitting...' : 'Generate Branded Video'}}
            </button>
          </div>
        </div>
      </div>
      <div class="w-full md:w-4/5 flex-shrink-0 md:flex flex-col ">
        <h1 class="text-lg mb-3 font-semibold">Branding Options:</h1>
        <quick-preset-selector
          presetName="Logo Animation:"
          :options="logoItems"
          class="mb-5"
          v-model="logo"
        />

        <quick-preset-selector
          presetName="Branding option:"
          :options="brandingItems"
          class="mb-5"
          v-model="branding"
        />

        <quick-preset-selector
          :disabled="mergeVideoette"
          presetName="Office Details:"
          class="mb-5"
          :options="officeDetailOptions"
          v-model="officeDetails"
          helptext="The contact details shown on the video outro"
        />
        <div class="flex items-center">
          <div class="box border mr-8 flex-no-shrink overflow-hidden"> <!-- Preview -->
            <canvas v-if="selectedThumbnail === 'frame'" id="output"
              v-show="thumbnail"
              class="box bg-cover"
            >
            </canvas>
            <div v-if="selectedThumbnail === null" class="box h-full flex justify-center items-center text-xs text-grey">
              No Preview Available
            </div>
            <div v-if="selectedThumbnail === 'custom'">
                <img class="box" v-if="thumbnail" :src="thumbnail" />
            </div>
            <div v-if="selectedThumbnail === 'logo'">
              <img class="box" :src="office.logo">
            </div>
          </div>
          <div class="w-full flex flex-col">
            <label class="mb-2 uppercase text-xs font-bold">Set thumbnail</label>
            <pl-select
              selectClass="p-2 border-gray-light bg-white shadow rounded pr-8 mb-4"
              class="w-full"
              v-model="selectedThumbnail"
            >
              <option :value="null">Select an option</option>
              <option
                v-for="(option, index) in thumbnailOptions"
                :key="index"
                :value="option.value"
              >{{ option.title }}</option>
            </pl-select>
            <div v-if="selectedThumbnail === 'frame'">
              <button :disabled="!file"
                class="bg-tertiary font-bold rounded flex items-center w-48 pl-4 py-1"
                :class="{ 'cursor-not-allowd opacity-50': !file }"
                @click="capture()"
              >
                <icon
                  name="pom"
                  class="w-8 text-white"
                  :center="false"
                />
                <span class="text-sm text-primary font-thin text-white bg-tertiary ml-3">Set thumbnail</span>
              </button>
              <div class="block mt-2 text-xs text-grey" >Drag you video to a desired frame and press the set thumbnail button to se your video thumbnail</div>
            </div>
            <div v-if="selectedThumbnail === 'custom'">
                <div :class="{ 'cursor-not-allowd opacity-50': !file }">
                    <label>
                        <div class="inline-block bg-tertiary active:bg-primary text-primary text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow cursor-pointer">
                            Select an image
                        </div>
                        <input type="file" class="opacity-0" accept="image/png, image/jpg, image/jpeg" @change="loadImage">
                    </label>
                </div>
            </div>
          </div>
        </div>
      </div>
       <div class="w-full flex container flex-col items-center mt-10 block md:hidden">
        <button
              class="mb-6 py-1 pl-2 pr-4 bg-secondary rounded flex items-center"
              :class="{ 'cursor-not-allowd': !file }"
              :disabled="!office || !file || loading || saving"
              @click="generate()"
            >
              <icon
                class="w-10 h-10"
                name="tick_circle"
                :center="false"
              />
              {{ loading ? 'Submitting...' : 'Generate Branded Video'}}
            </button>
         </div>
    </div>
  </div>
</template>

<script>
import Branding from '@/components/Videoettes/Branding'
import Transitions from '@/components/Videoettes/Transitions'
import CallToAction from '@/components/Videoettes/CallToAction'
import BackingMusic from '@/components/Videoettes/BackingMusic'
import LogoAnimation from '@/components/Videoettes/LogoAnimation'
import VideoetteSelector from '@/components/Videoettes/VideoetteSelector'
import Tabs from '@/components/Videoettes/Tabs'
import Subscription from '@/components/Videoettes/Subscription'
import QuickPresetSelector from '@/components/Videoettes/QuickPresetSelector'
import { mapState, mapMutations, mapActions } from 'vuex'
import { truncate } from '@/helpers'
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import http from 'axios'
import {
  FC_NETWORK_ID,
  FC_INTL_NETWORK_ID
} from '@/consts'

export default {
  name: 'Settings',

  props: ['page'],

  components: {
    Tabs,
    Branding,
    Transitions,
    CallToAction,
    BackingMusic,
    LogoAnimation,
    Subscription,
    QuickPresetSelector,
    VideoetteSelector
  },

  computed: {
    ...mapState({
      saving: state => state.savingBrandingPresets,
      office: state => state.selectedOffice,
      logoItems: state => state.videoettes.logoItems,
      brandingItems: state => [{ id: null, 'title': 'None' }].concat(state.videoettes.brandingItems),
      callToActionItems: state => state.videoBrandingTool.callToActionItems,
      selectedVideoBradingOption: state => state.selectedVideoBradingOption,
      transitionItems: state => state.videoettes.brandingItems,
      system: state => state.system,
      profile: state => state.profile_v2
    }),
    logo: {
      get () {
        return this.selectedVideoBradingOption.logo
      },
      set (val) {
        this.setVideoBrandingLogo(val)
      }
    },
    branding: {
      get () {
        return this.selectedVideoBradingOption.branding
      },
      set (val) {
        this.setVideoBrandingOption(val)
      }
    },
    mergeVideoette: {
      get () {
        return this.selectedVideoBradingOption.mergeVideoette
      },
      set (val) {
        this.setMergeVideoetteOption(val)
        if (val && !this.videoName) {
          this.videoName = val.display_address
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      debug: 0,
      show: false,
      file: '',
      showPresets: false,
      showModal: null,
      showModalVideo: false,
      tab: 'Branding',
      videoName: '',
      uploadPercent: 0,
      errors: new ErrorBag(),
      officeDetailOptions: [
        { id: 'sales', title: 'Sales' },
        { id: 'lettings', title: 'Lettings' }
      ],
      officeDetails: localStorage.getItem('vb_office_details')
        ? JSON.parse(localStorage.getItem('vb_office_details'))
        : { id: 'sales', title: 'Sales' },
      thumbnail: null,
      selectedThumbnail: null,
      thumbnailFile: null,
      thumbnailOptions: [
        { value: 'custom', title: 'Upload your custom image' },
        { value: 'frame', title: 'Frame from the video' },
        { value: 'logo', title: 'Use office logo' }
      ],
      fc_network_array: [
        FC_NETWORK_ID,
        FC_INTL_NETWORK_ID
      ]
    }
  },
  methods: {
    truncate,
    ...mapActions([
      'getVideoetteSettings',
      'displayToastNotification'
    ]),
    ...mapMutations([
      'setVideoBrandingLogo',
      'setVideoBrandingOption',
      'setMergeVideoetteOption'
    ]),

    async uploadVideo () {
      const extension = this.file.name.split('.').pop()
      const response = await api.post('signed-upload', {
        'disk': 'video_upload',
        'extension': extension
      })

      let headers = response.data.headers
      if ('Host' in headers) {
        delete headers.Host
      }

      await http.put(response.data.url, this.file, {
        headers: headers,
        onUploadProgress: (progressEvent) => {
          this.uploadPercent = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
        }
      })

      response.data.extension = extension

      return response.data
    },

    async generate () {
      if (!this.videoName) {
        this.errors.store({
          errors: { name: ['Name is required'] }
        })
        return
      }

      this.errors.clear()
      this.loading = true

      const upload = await this.uploadVideo().catch(() => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-exclamation',
          title: 'Generation failed',
          info: 'Unable to upload your video. Please try again later.'
        })
        this.loading = false
        this.uploadPercent = 0
      })

      api.post('/branded-video', {
        'office_id': this.office.id,
        'name': this.videoName,
        'key': upload.key,
        'videoette_id': this.mergeVideoette ? this.mergeVideoette.id : undefined,
        'office_details': this.officeDetails ? this.officeDetails.id : undefined,
        'thumbnail': this.thumbnail ? this.thumbnail.id : 'logo'
      })
        .then(response => {
          var videoId = response.data.video_id
          if (this.selectedThumbnail === 'logo') {
            this.uploadThumbnail(videoId, 'logo')
          }
          if (this.selectedThumbnail === 'custom') {
            this.uploadThumbnail(videoId, 'custom')
          }
          if (this.selectedThumbnail === 'frame') {
            this.uploadThumbnail(videoId, 'frame')
          }
          this.videoName = ''
          this.file = null
          this.mergeVideoette = null
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Video submitted successfully',
            info: 'Your branded video is being prepared, we\'ll notify you when it\'s ready'
          })
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            this.errors.store(response.data)
          } else {
            this.displayToastNotification({
              type: 'danger',
              icon: 'fa-exclamation',
              title: 'Generation failed',
              info: response.data.message
            })
          }
        })
        .finally(() => {
          this.loading = false
          this.uploadPercent = 0
        })
    },
    uploadThumbnail (videoId, type) {
      var data = new FormData()
      data.set('video_id', videoId)
      data.set('thumbnail_type', type)
      data.set('office_id', this.office.id)
      if (type === 'frame') {
        data.set('thumbnail', this.thumbnail)
      }
      if (type === 'custom') {
        data.append('thumbnail', this.thumbnailFile)
      }
      api.post('/set-thumbnail', data)
        .then(response => {
          this.selectedThumbnail = null
        })
    },
    capture () {
      let canvas = document.getElementById('output')
      let video = document.getElementById('videoLength')
      canvas.width = 1920
      canvas.height = 1080
      let ctx = canvas.getContext('2d')
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
      this.thumbnail = canvas.toDataURL('image/jpeg')
    },

    loadImage (e) {
      const imageFile = e.target.files[0]
      this.thumbnailFile = imageFile
      this.thumbnail = URL.createObjectURL(imageFile)
    },
    storeVideoBradingOption (brandingOption) {
      this.$store.commit('setVideoBrandingOption', brandingOption)
    },
    storeVideoBrandingCallToAction (callToActionoption) {
      this.$store.commit('setVideoBraningCallToAction', callToActionoption.id)
    },
    storeVideoAudioOption (AudioOption) {
      this.$store.commit('setAudioBradingOption', AudioOption.id)
    },
    storeVideoBrandingLogo (logoOption) {
      this.$store.commit('setVideoBrandingLogo', logoOption.id)
    },
    storeVideoBrandingPresenter (presenterOption) {
      this.$store.commit('setPresenterBrandingOption', presenterOption)
    },
    storemergeVideoetteOption (mergeVideoetteOption) {
      this.$store.commit('setMergeVideoetteOption', mergeVideoetteOption)
    },
    loadVideo () {
      this.file = this.$refs.videoFile.files[0]
      var file = this.$refs.videoFile.files[0]
      var type = file.type
      var videoNode = document.querySelector('video')
      var canPlay = videoNode.canPlayType(type)
      if (canPlay === '') canPlay = 'no'
      var fileURL = URL.createObjectURL(file)
      videoNode.src = fileURL
      this.validateFile()
    },
    validateFile () {
      var video = document.getElementById('videoLength')
      video.preload = 'metadata'
      video.onloadedmetadata = function () {
        var seconds = Math.floor(video.duration)
        if (seconds > 600 && this.profile.type > 2) {
          this.removefile()
          this.showModalVideo = true
        } else if (!this.videoName) {
          this.videoName = this.file.name
        }
      }.bind(this)
    },
    removefile () {
      document.getElementById('videoLength').pause()
      this.file = ''
      this.show = false
      this.$refs.videoFile.value = null
    }
  },

  watch: {
    selectedOffice () {
      this.getVideoetteSettings()
    },

    selectedThumbnail () {
      this.thumbnail = null
    },

    mergeVideoette (val) {
      if (!val) return

      this.officeDetails = { id: val.department.toLowerCase(), title: val.department }
    },

    officeDetails (val) {
      localStorage.setItem('vb_office_details', JSON.stringify(val))
    }
  },

  mounted () {
    this.getVideoetteSettings()
  }
}
</script>

<style scoped>
.videoette-image-preview {
  width: 8em;
  height: 4.5em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.div {
  height: 150px;
  width: 600px;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  outline: 1px dashed #dcdcdc;
  background-color: #f9f9fa;
}

.videoPlayer {
  height: 150px;
  width: 600px;
}

/* .generateButton {
  opacity: 0.2;
}  */

video,
input {
  display: block;
}

input {
  width: 100%;
}

.info {
  background-color: aqua;
}

.error {
  background-color: red;
  color: white;
}

.anim-width {
  transition: width 0.2s;
}
.box {
  width: 160px;
  height: 90px;
}
</style>
